var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M14.983 8.992v3.333q.002.325-.034.625c-.191 2.25-1.516 3.367-3.958 3.367h-.333c-.209 0-.409.1-.534.266l-1 1.334c-.441.591-1.158.591-1.6 0l-1-1.334a.77.77 0 0 0-.533-.266h-.333c-2.659 0-3.992-.659-3.992-3.992V8.992c0-2.442 1.125-3.767 3.367-3.959.2-.025.408-.033.625-.033h5.333c2.658 0 3.992 1.333 3.992 3.992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M18.317 5.658V8.99q-.002 3.673-3.367 3.958c.025-.2.033-.408.033-.625V8.991c0-2.658-1.333-3.992-3.992-3.992H5.659q-.325-.002-.625.034C5.225 2.79 6.55 1.666 8.992 1.666h5.333c2.658 0 3.992 1.333 3.992 3.992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M11.247 11.042h.007M8.329 11.042h.007M5.413 11.042h.007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chatWhite.366568b61d20c3f486f0a935811d693d.svg";
export { ForwardRef as ReactComponent };